import { TextField, MenuItem } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { getIn, type FormikProps } from 'formik';

import { state } from '../../../utils/config';
import type { CandidateProps } from '../../../models'; // Assuming you have this type defined

interface PersonalInfoProps {
	formik: FormikProps<{ candidate: CandidateProps }>;
}

export const PersonalInfo: React.FC<PersonalInfoProps> = ({ formik }) => {
	return (
		<Grid container spacing={2}>
			<Grid size={{ md: 6 }}>
				<TextField
					fullWidth
					margin="dense"
					id="firstname"
					name="candidate.firstname"
					label="First Name"
					variant="standard"
					value={formik.values.candidate.firstname}
					onChange={formik.handleChange}
					error={Boolean(getIn(formik.touched, 'candidate.firstname') && getIn(formik.errors, 'candidate.firstname'))}
					helperText={getIn(formik.touched, 'candidate.firstname') && getIn(formik.errors, 'candidate.firstname')}
				/>
			</Grid>
			<Grid size={{ md: 6 }}>
				<TextField
					fullWidth
					margin="dense"
					id="lastname"
					name="candidate.lastname"
					label="Last Name"
					variant="standard"
					value={formik.values.candidate.lastname}
					onChange={formik.handleChange}
					error={Boolean(getIn(formik.touched, 'candidate.lastname') && getIn(formik.errors, 'candidate.lastname'))}
					helperText={getIn(formik.touched, 'candidate.lastname') && getIn(formik.errors, 'candidate.lastname')}
				/>
			</Grid>
			<Grid size={{ md: 6 }}>
				<TextField
					fullWidth
					margin="dense"
					id="phone"
					name="candidate.phone"
					label="Phone"
					variant="standard"
					inputProps={{ inputMode: 'numeric', maxLength: 10 }}
					value={formik.values.candidate.phone}
					onChange={formik.handleChange}
					error={Boolean(getIn(formik.touched, 'candidate.phone') && getIn(formik.errors, 'candidate.phone'))}
					helperText={getIn(formik.touched, 'candidate.phone') && getIn(formik.errors, 'candidate.phone')}
				/>
			</Grid>
			<Grid size={{ md: 6 }}>
				<TextField
					fullWidth
					margin="dense"
					id="email"
					name="candidate.email"
					label="Email"
					variant="standard"
					type="email"
					value={formik.values.candidate.email}
					onChange={formik.handleChange}
					error={Boolean(getIn(formik.touched, 'candidate.email') && getIn(formik.errors, 'candidate.email'))}
					helperText={getIn(formik.touched, 'candidate.email') && getIn(formik.errors, 'candidate.email')}
				/>
			</Grid>
			<Grid size={{ xs: 6 }}>
				<TextField
					fullWidth
					margin="dense"
					id="employer"
					name="candidate.employer"
					label="Employer"
					variant="standard"
					value={formik.values.candidate.employer}
					onChange={formik.handleChange}
					error={Boolean(getIn(formik.touched, 'candidate.employer') && getIn(formik.errors, 'candidate.employer'))}
					helperText={getIn(formik.touched, 'candidate.employer') && getIn(formik.errors, 'candidate.employer')}
				/>
			</Grid>
			<Grid size={{ xs: 6 }}>
				<TextField
					fullWidth
					margin="dense"
					id="jobRole"
					name="candidate.jobRole"
					label="Job Role"
					variant="standard"
					value={formik.values.candidate.jobRole}
					onChange={formik.handleChange}
					error={Boolean(getIn(formik.touched, 'candidate.jobRole') && getIn(formik.errors, 'candidate.jobRole'))}
					helperText={getIn(formik.touched, 'candidate.jobRole') && getIn(formik.errors, 'candidate.jobRole')}
				/>
			</Grid>
			<Grid size={{ md: 6 }}>
				<TextField
					fullWidth
					margin="dense"
					id="addrpostcode"
					name="candidate.addrPostcode"
					label="Postcode"
					variant="standard"
					inputProps={{ inputMode: 'numeric', maxLength: 4 }}
					value={formik.values.candidate.addrPostcode}
					onBlur={formik.handleBlur}
					onChange={formik.handleChange}
					error={Boolean(
						getIn(formik.touched, 'candidate.addrPostcode') && getIn(formik.errors, 'candidate.addrPostcode'),
					)}
					helperText={getIn(formik.touched, 'candidate.addrPostcode') && getIn(formik.errors, 'candidate.addrPostcode')}
				/>
			</Grid>
			<Grid size={{ md: 6 }}>
				<TextField
					select
					fullWidth
					margin="dense"
					id="addrstate"
					name="candidate.addrState"
					label="State"
					variant="standard"
					value={formik.values.candidate.addrState}
					onBlur={formik.handleBlur}
					onChange={formik.handleChange}
					error={Boolean(getIn(formik.touched, 'candidate.addrState') && getIn(formik.errors, 'candidate.addrState'))}
					helperText={getIn(formik.touched, 'candidate.addrState') && getIn(formik.errors, 'candidate.addrState')}
				>
					{state.map((s) => (
						<MenuItem key={s.name} value={s.label}>
							{s.label}
						</MenuItem>
					))}
				</TextField>
			</Grid>
		</Grid>
	);
};
